
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqETEiW_0ueIRfK_45MbI6_45xHlquQeUUg42vagBfCTsFDM8Meta } from "/codebuild/output/src594263955/src/src/pages/faq.vue?macro=true";
import { default as menuR9pupZYtQWDYkyFN14uHQlMVRyQxdWNHBOhUfJj9FyAMeta } from "/codebuild/output/src594263955/src/src/pages/menu.vue?macro=true";
import { default as indexHBPhPkoFSs48bvQD889PCgadPANVKoy7fSoSywMOO_45gMeta } from "/codebuild/output/src594263955/src/src/pages/index.vue?macro=true";
import { default as contactM_L47ZXLTjTkzAnxkAbQN69n5sxZwhG6rzMBgOYzCrQMeta } from "/codebuild/output/src594263955/src/src/pages/contact.vue?macro=true";
import { default as tutorialm6RZJVfVeVRKI3sTcZkIkRf5tatxRK1bLBhy_45Z68vrAMeta } from "/codebuild/output/src594263955/src/src/pages/tutorial.vue?macro=true";
import { default as agreementyQ5m2eIwDWiUj7cdn4_45JWSkSuwB9FjqRKvydd1AGZsIMeta } from "/codebuild/output/src594263955/src/src/pages/agreement.vue?macro=true";
import { default as about_45passjd7whzeGFPyLjQhcFbNms2VLxJhdVBxrS5UY0eFppZoMeta } from "/codebuild/output/src594263955/src/src/pages/about-pass.vue?macro=true";
import { default as indexfAlPId5BjDTgOjc64EBb6X0fM2nUC848eIwonVWqAIYMeta } from "/codebuild/output/src594263955/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93P4FQaRB_45fZfnsakpIPayVNmQOREk_45yboXfigVyK7bm8Meta } from "/codebuild/output/src594263955/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenance9nvmvTqFl48xxiu0zveAWVWYwhkxgsF8xvAbyZ5YfGMMeta } from "/codebuild/output/src594263955/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_935p1QpBQd61TblJ5kHLIF1HWGNr_45N7TrDxh8uLrlcDK4Meta } from "/codebuild/output/src594263955/src/src/pages/notice/[id].vue?macro=true";
import { default as indexp7qloTkD2AnUsf35_45rdVr3DTYjYIO7z2py8E3mXE3BsMeta } from "/codebuild/output/src594263955/src/src/pages/coupon/index.vue?macro=true";
import { default as indexsNEJlZ2CpWc1DCWX19Qpbo9l45eX1TR_45qdDtGtUf4aYMeta } from "/codebuild/output/src594263955/src/src/pages/mypage/index.vue?macro=true";
import { default as indexXS5pdT00wlM7CSofpRoXFrrYJzuNfQ27K_LVV0dy2_EMeta } from "/codebuild/output/src594263955/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93hwp_45K9B8GyWAFmbh_NDGU9P5MvX4aKaQfbFAIAyMlJ4Meta } from "/codebuild/output/src594263955/src/src/pages/parking/[id].vue?macro=true";
import { default as indexbadRPLVLDSemSo6eWo5KxvsuxThD3AngIuCLB105dlUMeta } from "/codebuild/output/src594263955/src/src/pages/history/index.vue?macro=true";
import { default as indexBK_45jbo3Pol8NhUGQozO_DOK5PVVLke_454WfAdp3oyOzIMeta } from "/codebuild/output/src594263955/src/src/pages/monthly/index.vue?macro=true";
import { default as indexfvDER3pNXmJeIxeLD2wtDBqffnhf7TS0vsxLZAKtjCkMeta } from "/codebuild/output/src594263955/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexwaBuM_456goHEDzp7IwF1mSM7CoLeIaF8QPcATXFAChogMeta } from "/codebuild/output/src594263955/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenaviQ_2gTxN3Cutx_fPHWBLysGGGRqsJR0SmUUoJPMMh1_0Meta } from "/codebuild/output/src594263955/src/src/pages/about-yumenavi.vue?macro=true";
import { default as edituTshGmR4KB6Efax4EZ8bXG3l6YBbRueCjMTIAQKwIHUMeta } from "/codebuild/output/src594263955/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementkzSsh1NoyZOgni0D29VqbhAZVPIka7_gtar_45IvxbTQIMeta } from "/codebuild/output/src594263955/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexrXOftDc7mtuAHmxNjbjmfZwChOC9YttKWIscNMaz5uUMeta } from "/codebuild/output/src594263955/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dbGrvfvMuIpAHnQtXPL9hwrCbbBTAj5za9KK4HchK1aUMeta } from "/codebuild/output/src594263955/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmmHNHcYTI23P3AM1XgNvIMFxbGevDJRZW38SkwnSS99sMeta } from "/codebuild/output/src594263955/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexAWjiEKbsWxbuKWZx6cySERIzo_HHsPUouskNlwgUaWwMeta } from "/codebuild/output/src594263955/src/src/pages/card/create/index.vue?macro=true";
import { default as indexN4TtK03ml_45PVpEF17eIWNzWHBgunSyIfkIklKOjMuyEMeta } from "/codebuild/output/src594263955/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmMoFq1elEMQTpzh0wBXPz4qOf_fT0EA0oERQ_RjqvHuIMeta } from "/codebuild/output/src594263955/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmL5PEzd8b4RDX3CWBaUIzHF4F3BTgRJU8O76aogB5H_IMeta } from "/codebuild/output/src594263955/src/src/pages/card/create/confirm.vue?macro=true";
import { default as complete30NeB9ECPxsMfsoDa4s2JHdtAPXTB5u6X45fMziElHAMeta } from "/codebuild/output/src594263955/src/src/pages/membership/complete.vue?macro=true";
import { default as registerIxefaegW07BcZgCD5eyq3uRymjjSIINVfRl7w1BqU08Meta } from "/codebuild/output/src594263955/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93CSkPnsCFDa_n5QNL_454tCcSPEen5aukANgQdtWIzYODQMeta } from "/codebuild/output/src594263955/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmhTgar_45IAiJ9R75616imYs06hQjMZ91_45XSWJ8itL4xcAMeta } from "/codebuild/output/src594263955/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93mjGEi7AHJi_F0fm7xkKlEYxKbmLz76JL1z8nU1A61Q0Meta } from "/codebuild/output/src594263955/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexpRzxgbPvozfYMeRh2MQiJ3paS2Vfg_45d4cmhsOe701U8Meta } from "/codebuild/output/src594263955/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codelwJvPZeOexxsfVXP0S_vOMA6uhtZlZJmLl1FmH9ZagMMeta } from "/codebuild/output/src594263955/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codemge3F6mcQlt_45fKfEGgELk9I7nV56u7cfPA5e_45dTRKU0Meta } from "/codebuild/output/src594263955/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeFcXMIVnEApcBrWjglwK9DA6HL71NHjhZ8DYedb7BwCoMeta } from "/codebuild/output/src594263955/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registercty4XiimtApf2T4Tvuum1cxDitmtyVydWB_eviI8uzYMeta } from "/codebuild/output/src594263955/src/src/pages/contact-form/register.vue?macro=true";
import { default as completeKpdRXAscdkpfIFHwirdkJRhwHNQjHh5WidOVpWi_YxEMeta } from "/codebuild/output/src594263955/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexyOrPvIyl8AcKJ08q7WIC_45HuU1r9LDvtaLVkyIyQ_rr0Meta } from "/codebuild/output/src594263955/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmMa7CowwdGsGzDQG7XDiBM3_45kmAUPpTjm2NWm6wgEWWcMeta } from "/codebuild/output/src594263955/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as complete49zEAgSiGktpueF46_LIjnqKKygmsQuVEdJd5VFJuqEMeta } from "/codebuild/output/src594263955/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexXLypLgOKsxRnHQQMxAvCyk3ain7TY0KBCLHbmrzhuVcMeta } from "/codebuild/output/src594263955/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_937jIn2ZmR_454i4bPP3n0QrPn7WHEKbL9GR4QSIr8oJjiMMeta } from "/codebuild/output/src594263955/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as complete_45TJrH_45y8g3lUsFLb801HDp1ymq15LfjQqrScezS3HWgMeta } from "/codebuild/output/src594263955/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasFyzMDx6VHax7gaoEIpzXnZmyV4_450yQAawXCJabd20EMMeta } from "/codebuild/output/src594263955/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sampleqFDBbZqRijLBbmWMVSYqoVyjx4yhKOuPdqHJ5IpZz4oMeta } from "/codebuild/output/src594263955/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailVAiZT4KNXAzCNYQxhuLhLLQHg0mQe8Bv8S_fzAAtoH8Meta } from "/codebuild/output/src594263955/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmRxMo_9DMks2HMcMv5MBNKAXZfUAcb_MHX0Y9an6AJ44Meta } from "/codebuild/output/src594263955/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentcT86mU1n_45V9hbFz0wglQQrqSzlo9LEdhN1vRBv_45klvEMeta } from "/codebuild/output/src594263955/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmde1mrqeo3KsWn1Zwp419mKzPzN0SGJzfg8tBhUKB8uIMeta } from "/codebuild/output/src594263955/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedateW0zeZkzMnHcmTQ8ppAbVENo4r7E3a87pFxqS0zghTpQMeta } from "/codebuild/output/src594263955/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as complete36hy7JTTMJDIT6Di9qirsX9_454aU7WHxhQh5OSlc9C10Meta } from "/codebuild/output/src594263955/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codeUNGfKJ2MzOIXGPAgBL8_45sR4nKi_JeJXuGkeUElKrqEEMeta } from "/codebuild/output/src594263955/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordzHGUaErhjVQnwxM1sp3B0tn3YqRgXuwAOv28VMbjzBwMeta } from "/codebuild/output/src594263955/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasnC_459W4H3w_aQ0aszL2YbND85qwdUg9Ry4Hw9Xz7G6HgMeta } from "/codebuild/output/src594263955/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerXpxHCpFjD_19KW_45cwNtROMom2VuZpbsqrftXAWDE9P8Meta } from "/codebuild/output/src594263955/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codeZ7CdKopmmP41JjPXTf9A7RzZ1g5Ydn5JAQ706oIXjgoMeta } from "/codebuild/output/src594263955/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexzbEIAEQvuC201c_45M11g4SPdY_b8HPDuvE5uT1wamwBIMeta } from "/codebuild/output/src594263955/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexQqqiS9Ab2hqbQTjM9fvQZB45itL64c8dyxnmdkKkpsQMeta } from "/codebuild/output/src594263955/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexa_45WanXsEXrTyO8IJINQGuFWzsp30fUlD2oH0Y37mctMMeta } from "/codebuild/output/src594263955/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexDrZlVRxRzb8R0gqJhPbJyzg9qpoYsCiyD9h0Ro1N3fUMeta } from "/codebuild/output/src594263955/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updatezi_45sYe7TyVM7zhSgqjaV3P842Exvi1I4bzPTF8j2gjEMeta } from "/codebuild/output/src594263955/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completeXqOMbwn5_JlDUfBmI2EfKRwo2ueXqFhvDKbfk96jiHwMeta } from "/codebuild/output/src594263955/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmkqO3vHieZK6Wc2bk1ym2pXMe9BGdi01cH_vBXf_JSUAMeta } from "/codebuild/output/src594263955/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexevXBzpztCac78ZP3ZCuw88Pyp0H4q9gDApxsZX_45VX2kMeta } from "/codebuild/output/src594263955/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completesGRwobHUcotx4_453aGqfkHG_qxLSyqLao7l_45Jw7PiHRQMeta } from "/codebuild/output/src594263955/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updatez_45T_p3Uaa2hjAEOYh_45rXtP8kNG5TJhz90yD317LwhzEMeta } from "/codebuild/output/src594263955/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexcBWT8QAqB0SGdHj74VyyOuPMf_45pLez_45mgPNhiEAFcDUMeta } from "/codebuild/output/src594263955/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexRWIULOz0AQ5OhrBKHbDb3PitE548J_QHeW9d0jQ2LooMeta } from "/codebuild/output/src594263955/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completeN2RA9mEerthHc5laZjVpweSSwi_45s3S5TmaHgghlk1roMeta } from "/codebuild/output/src594263955/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexF4_Xvd765kbJzEaRb7u1De_456O50qoC9jN8TDcgkAgg0Meta } from "/codebuild/output/src594263955/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codej9lz2NinFQpCk7U2Zuh2OLzcof8AtM8jt3wTToRsEt4Meta } from "/codebuild/output/src594263955/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as index4gRkAZqjrgTt1SzPPpmwf6mb6Pp6yh6enEnWGP91jmAMeta } from "/codebuild/output/src594263955/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexhAC_45Fxg_he69UEmUXO6_5TJo8IPnUevY3g86h_45q8vL0Meta } from "/codebuild/output/src594263955/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexDkZvp5eCnY3Wt29YC1xBnBYwTUsosYY1he_45mkFKa6MsMeta } from "/codebuild/output/src594263955/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updaterFXMCKdG6DNV5nkjyrehFIoCzLkzk8hN761qm6_45iIYcMeta } from "/codebuild/output/src594263955/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmkFURYFL6BIRFQVbt5FBX_7FnpMaDpRh_4nNbLG09STQMeta } from "/codebuild/output/src594263955/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src594263955/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menuR9pupZYtQWDYkyFN14uHQlMVRyQxdWNHBOhUfJj9FyAMeta || {},
    component: () => import("/codebuild/output/src594263955/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(indexHBPhPkoFSs48bvQD889PCgadPANVKoy7fSoSywMOO_45gMeta || {}), ...{"middleware":["search-params"]} },
    component: () => import("/codebuild/output/src594263955/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src594263955/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src594263955/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src594263955/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src594263955/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src594263955/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src594263955/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src594263955/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src594263955/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexp7qloTkD2AnUsf35_45rdVr3DTYjYIO7z2py8E3mXE3BsMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src594263955/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src594263955/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src594263955/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src594263955/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexbadRPLVLDSemSo6eWo5KxvsuxThD3AngIuCLB105dlUMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src594263955/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src594263955/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexfvDER3pNXmJeIxeLD2wtDBqffnhf7TS0vsxLZAKtjCkMeta || {},
    component: () => import("/codebuild/output/src594263955/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexwaBuM_456goHEDzp7IwF1mSM7CoLeIaF8QPcATXFAChogMeta || {},
    component: () => import("/codebuild/output/src594263955/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src594263955/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src594263955/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src594263955/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src594263955/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src594263955/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src594263955/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexAWjiEKbsWxbuKWZx6cySERIzo_HHsPUouskNlwgUaWwMeta || {},
    component: () => import("/codebuild/output/src594263955/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src594263955/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmMoFq1elEMQTpzh0wBXPz4qOf_fT0EA0oERQ_RjqvHuIMeta || {},
    component: () => import("/codebuild/output/src594263955/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmL5PEzd8b4RDX3CWBaUIzHF4F3BTgRJU8O76aogB5H_IMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src594263955/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: complete30NeB9ECPxsMfsoDa4s2JHdtAPXTB5u6X45fMziElHAMeta || {},
    component: () => import("/codebuild/output/src594263955/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerIxefaegW07BcZgCD5eyq3uRymjjSIINVfRl7w1BqU08Meta || {},
    component: () => import("/codebuild/output/src594263955/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src594263955/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmhTgar_45IAiJ9R75616imYs06hQjMZ91_45XSWJ8itL4xcAMeta || {},
    component: () => import("/codebuild/output/src594263955/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src594263955/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src594263955/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codelwJvPZeOexxsfVXP0S_vOMA6uhtZlZJmLl1FmH9ZagMMeta || {},
    component: () => import("/codebuild/output/src594263955/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codemge3F6mcQlt_45fKfEGgELk9I7nV56u7cfPA5e_45dTRKU0Meta || {},
    component: () => import("/codebuild/output/src594263955/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeFcXMIVnEApcBrWjglwK9DA6HL71NHjhZ8DYedb7BwCoMeta || {},
    component: () => import("/codebuild/output/src594263955/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registercty4XiimtApf2T4Tvuum1cxDitmtyVydWB_eviI8uzYMeta || {},
    component: () => import("/codebuild/output/src594263955/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src594263955/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src594263955/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmMa7CowwdGsGzDQG7XDiBM3_45kmAUPpTjm2NWm6wgEWWcMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src594263955/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: complete49zEAgSiGktpueF46_LIjnqKKygmsQuVEdJd5VFJuqEMeta || {},
    component: () => import("/codebuild/output/src594263955/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexXLypLgOKsxRnHQQMxAvCyk3ain7TY0KBCLHbmrzhuVcMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src594263955/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src594263955/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: complete_45TJrH_45y8g3lUsFLb801HDp1ymq15LfjQqrScezS3HWgMeta || {},
    component: () => import("/codebuild/output/src594263955/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src594263955/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sampleqFDBbZqRijLBbmWMVSYqoVyjx4yhKOuPdqHJ5IpZz4oMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src594263955/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailVAiZT4KNXAzCNYQxhuLhLLQHg0mQe8Bv8S_fzAAtoH8Meta || {},
    component: () => import("/codebuild/output/src594263955/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmRxMo_9DMks2HMcMv5MBNKAXZfUAcb_MHX0Y9an6AJ44Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src594263955/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentcT86mU1n_45V9hbFz0wglQQrqSzlo9LEdhN1vRBv_45klvEMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src594263955/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmde1mrqeo3KsWn1Zwp419mKzPzN0SGJzfg8tBhUKB8uIMeta || {},
    component: () => import("/codebuild/output/src594263955/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src594263955/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(complete36hy7JTTMJDIT6Di9qirsX9_454aU7WHxhQh5OSlc9C10Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src594263955/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codeUNGfKJ2MzOIXGPAgBL8_45sR4nKi_JeJXuGkeUElKrqEEMeta || {},
    component: () => import("/codebuild/output/src594263955/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordzHGUaErhjVQnwxM1sp3B0tn3YqRgXuwAOv28VMbjzBwMeta || {},
    component: () => import("/codebuild/output/src594263955/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src594263955/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerXpxHCpFjD_19KW_45cwNtROMom2VuZpbsqrftXAWDE9P8Meta || {},
    component: () => import("/codebuild/output/src594263955/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codeZ7CdKopmmP41JjPXTf9A7RzZ1g5Ydn5JAQ706oIXjgoMeta || {},
    component: () => import("/codebuild/output/src594263955/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src594263955/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src594263955/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src594263955/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src594263955/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src594263955/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src594263955/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src594263955/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src594263955/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src594263955/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src594263955/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src594263955/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src594263955/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src594263955/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src594263955/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src594263955/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src594263955/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src594263955/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src594263955/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src594263955/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src594263955/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]